module.exports = __webpack_public_path__ + "static/media/LemonShark.d750f3f1.png";